import * as React from 'react';
import './listItem.scss';

interface ListItemProps {
    children?: React.ReactNode;
}

const ListItem = (props: ListItemProps): JSX.Element => {
    return <li className="list-item">
        {props.children}
    </li>;
};

export { ListItem };
export default ListItem;